/* eslint-disable  */
//@ts-nocheck

import React from 'react';
import _ from 'underscore';

import helpers from './helpers';
import Tooltip from './Tooltip';
import NameAutocomplete from './NameAutocomplete';
import ExerciseEditHeader from './ExerciseEditHeader';
import { Typography } from '@mui/material';
import { AddFromVideosModal } from '@client/new/pages/influencer/videos/components/AddFromVideosModal';
import { videoToMedia } from '@client/new/pages/influencer/videos/videos.helpers';
import { ExerciseUpload } from '@client/new/pages/influencer/exercise/ExerciseUpload';
import { mixTrack } from '@services/mixpanel';
import exerciseVideoImage from '/static/images/exercise-video.jpg';
import howToShootImage from '/static/images/how-to-shoot@2x.png';

class SingleExerciseEdit extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isUploadingMedia: false,
    };
    this.merge = this.merge.bind(this);
    this.onToggleMinimize = this.onToggleMinimize.bind(this);
    this.descriptionChanged = this.descriptionChanged.bind(this);
    this.restChanged = this.restChanged.bind(this);
    this.nameChanged = this.nameChanged.bind(this);
    this.mediaChanged = this.mediaChanged.bind(this);
    this.addSet = this.addSet.bind(this);
    this.deleteSet = this.deleteSet.bind(this);
    this.editSet = this.editSet.bind(this);
    this.validate = this.validate.bind(this);

    const url = new URL(window.location.href);
    const mediaJson = url.searchParams.get('video');
    if (mediaJson) {
      this.handleLibaryVideoSelect(JSON.parse(mediaJson));
    }
  }
  merge(newData) {
    let data = _.extend(this.props.data, newData);
    this.props.onChange(this.props.id, data);
  }
  onToggleMinimize() {
    if (this.props.minimizeDisabled) return;
    this.merge({ minimized: !this.props.data.minimized });
  }
  descriptionChanged(ev) {
    this.merge({ description: ev.target.value });
  }
  restChanged(rest) {
    this.merge({ rest });
  }
  nameChanged(name) {
    this.merge({ name });
  }
  mediaChanged(media) {
    this.merge({ media: media });
    mixTrack({
      type: 'Video Uploaded',
      payload: {
        'Upload Location': 'Workout Creation',
        'Video Type': 'Short',
      },
    });
  }
  addSet() {
    let sets = this.props.data.sets;
    var repUnit = 'reps';
    if (this.props.data.sets) {
      // if this is 'first rep', it's actually a duration
      if (this.props.data.sets.length === 0) {
        this.merge({
          sets: [{ reps: ['', 'min'] }],
        });
        return;
      }
      // if you've just created a 'custom' and need a 'single', turn reps into reps
      else if (
        this.props.data.sets.length === 1 &&
        this.props.data.sets[0].reps[0] === ''
      ) {
        this.merge({
          sets: [{ reps: ['', 'reps'] }, { reps: ['', 'reps'] }],
        });
        return;
      }
      // if previous set had a unit, then clone that unit to ease data entry
      else if (
        this.props.data.sets[this.props.data.sets.length - 1] &&
        this.props.data.sets[this.props.data.sets.length - 1].reps instanceof
          Object
      ) {
        repUnit = this.props.data.sets[this.props.data.sets.length - 1].reps[1];
        sets.push(helpers.generateSingleExerciseItem(repUnit));
        this.merge({ sets });
      }
    } else {
      // create first set
      this.merge({
        sets: [{ reps: ['', 'min'] }],
      });
    }
  }
  deleteSet(id) {
    let setsLeft = _.without(this.props.data.sets, this.props.data.sets[id]);
    this.merge({
      sets: setsLeft,
    });
    // remove rest if there's just one set
    if (setsLeft.length === 1) {
      this.merge({
        rest: null,
      });
    }
  }
  editSet(id, data) {
    var sets = this.props.data.sets;
    sets[id] = data;
    this.merge({
      sets: sets,
    });
  }
  validate(attribute) {
    if (
      this.props.tree &&
      this.props.tree[attribute] &&
      this.props.tree[attribute].length > 0
    ) {
      return 'invalid';
    }
    return;
  }

  handleAddFromVideos = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    this.setState({
      displayAddFromVideosModal: true,
    });
  };

  handleLibaryVideoSelect = (video: Video) => {
    this.props.onChange(this.props.id, {
      media: videoToMedia(video),
      name: video.name,
    });
  };

  render() {
    //console.log('[SingleExerciseEdit] render() called.', this.props.data);
    let message = '';

    var items = [];
    if (
      this.props.data &&
      this.props.data.sets &&
      this.props.data.sets.length > 0
    ) {
      for (var i = 0; i < this.props.data.sets.length; i++) {
        items.push(
          <SingleExerciseEditItem
            key={i}
            id={i}
            data={this.props.data.sets[i]}
            overrideLabel={
              this.props.data.sets && this.props.data.sets.length === 1
                ? 'Duration'
                : null
            }
            onDelete={this.deleteSet}
            onChange={this.editSet}
            tree={
              this.props.tree && this.props.tree.sets
                ? this.props.tree.sets[i]
                : null
            }
            setUploadingMedia={this.props.setUploadingMedia}
          />,
        );
      }
    }

    let buttonAddToLibrary = null;

    let restEdit = null;
    if (this.props.data.sets && this.props.data.sets.length > 1) {
      restEdit = (
        <RestEdit onChange={this.restChanged} value={this.props.data.rest} />
      );
    }

    let addLabel = 'Add Sets';
    if (this.props.data.sets && this.props.data.sets.length === 0) {
      addLabel = 'Add Duration';
    }
    let addLabelStyle = {};
    if (this.props.data.sets && this.props.data.sets.length > 0) {
      addLabelStyle = { margin: '10px 0' };
    }

    let content = (
      <div className="workoutForm">
        <div className="trinity">
          <div className="first">
            <label>Exercise video</label>
            <div>
              <ExerciseUpload
                influencerId={this.props.influencerId}
                video={this.props.data.media}
                onChange={this.mediaChanged}
                setUploadingMedia={this.props.setUploadingMedia}
              />
            </div>
            <div className="row">
              <Tooltip className="info">
                <div className="mobile">
                  <section>
                    <Typography variant="h1">Exercise video</Typography>
                    <p>
                      Record yourself doing just one repetition of the exercise.
                      They are displayed in fullscreen, so make sure to shoot in
                      portrait!
                    </p>
                    <ul>
                      <li>
                        <strong>Maximum size &amp; length:</strong> 100 mb and
                        1-5 sec.
                      </li>
                      <li>
                        <strong>Supported browsers:</strong> Safari or Chrome
                      </li>
                    </ul>
                  </section>
                </div>
                <div className="large">
                  <section>
                    <Typography variant="h1">Exercise video</Typography>
                    <p>
                      Record yourself doing just one repetition of the exercise.
                      They are displayed in fullscreen, so make sure to shoot in
                      portrait!
                    </p>
                    <ul>
                      <li>
                        <strong>Format:</strong> Portrait (9:16)
                      </li>
                      <li>
                        <strong>Size:</strong> max 100 mb
                      </li>
                      <li>
                        <strong>Length:</strong> 1-5 sec.
                      </li>
                      <li>
                        <strong>Browser:</strong> Safari or Chrome
                      </li>
                    </ul>
                  </section>
                  <section>
                    <img className="shoot-vertical" src={exerciseVideoImage} />
                  </section>
                </div>
              </Tooltip>
              <Tooltip className="camera">
                <div className="mobile">
                  <section>
                    <Typography variant="h1">How to shoot</Typography>
                    <p>
                      The video will be shown in fullscreen, so shoot with your
                      iPhone in portrait mode (9:16).
                    </p>
                    <p>
                      We suggest you record just one repetition and keep it
                      under 5 seconds in length.
                    </p>
                  </section>
                </div>
                <div className="large">
                  <section>
                    <Typography variant="h1">How to shoot</Typography>
                    <p>
                      The video will be shown in fullscreen, so shoot with your
                      iPhone in portrait mode (9:16).
                    </p>
                    <p>
                      We suggest you record just one repetition and keep it
                      under 5 seconds in length.
                    </p>
                  </section>
                  <section>
                    <img className="shoot-vertical" src={howToShootImage} />
                  </section>
                </div>
              </Tooltip>
              <Tooltip className="scissors">
                <div className="mobile">
                  <section>
                    <Typography variant="h1">How to edit</Typography>
                    <p>
                      Use the app{' '}
                      <a href="https://itunes.apple.com/us/app/splice-video-editor-movie/id409838725?mt=8">
                        Splice
                      </a>{' '}
                      from the App Store to trim your video.
                    </p>
                    <p>
                      Compress to have longer video. Use{' '}
                      <a href="https://itunes.apple.com/us/app/video-compressor/id482465886?mt=8">
                        Video Compressor
                      </a>{' '}
                      to compress to less than 100 mb if necessary.
                    </p>
                  </section>
                </div>
                <div className="large">
                  <section>
                    <Typography variant="h1">How to edit (desktop)</Typography>
                    <p>
                      Use{' '}
                      <a target="_blank" href="http://online-video-cutter.com">
                        Video Cutter
                      </a>{' '}
                      to crop your video and compress it to less than 100 mb if
                      necessary. Select ‘720p’ in quality and ‘mp4’ in format.
                    </p>
                    <p>Remember to shoot with iPhone in portrait mode.</p>
                  </section>
                  <section>
                    <Typography variant="h1">How to edit (mobile)</Typography>
                    <p>
                      Use the app{' '}
                      <a href="https://itunes.apple.com/us/app/splice-video-editor-movie/id409838725?mt=8">
                        Splice
                      </a>{' '}
                      from the App Store to trim your video.
                    </p>
                    <p>
                      Compress to have longer video. Use{' '}
                      <a href="https://itunes.apple.com/us/app/video-compressor/id482465886?mt=8">
                        Video Compressor
                      </a>{' '}
                      to compress to less than 100 mb if necessary.
                    </p>
                  </section>
                </div>
              </Tooltip>
            </div>
          </div>
          <div className="second">
            <label>
              Exercise name<strong className="warning">*</strong>
            </label>
            <NameAutocomplete
              value={this.props.data.name}
              onChange={(e) => {
                if (e && e.name) {
                  this.nameChanged(e.name);
                }
                if (e && e.description) {
                  this.descriptionChanged({ target: { value: e.description } });
                }
                this.nameChanged(e.name);
              }}
              placeholder="Enter exercise title"
              maxLength={60}
            />
            <label>Exercise description</label>
            <textarea
              ref="description"
              value={this.props.data.description}
              onChange={this.descriptionChanged}
              placeholder="Enter description"
              maxLength={2000}
            />
          </div>
          <div className="third">
            <label>Exercise details</label>
            {items}
            <a
              onClick={this.addSet}
              className="actionLink add-button"
              style={addLabelStyle}
            >
              {addLabel}
            </a>
            <br />
            {restEdit}
            <br />
            <span className="warning">{message}</span>
          </div>
          {buttonAddToLibrary}
        </div>
      </div>
    );
    return (
      <div className="singleExerciseEdit">
        <AddFromVideosModal
          isOpen={this.state.displayAddFromVideosModal}
          influencerId={this.props.influencerId}
          onClose={() => this.setState({ displayAddFromVideosModal: false })}
          onSave={(video: Video) => {
            this.setState({ displayAddFromVideosModal: false });
            this.handleLibaryVideoSelect(video);
          }}
        />
        <ExerciseEditHeader
          id={this.props.id}
          exerciseLength={this.props.exerciseLength}
          index={this.props.index}
          data={this.props.data}
          minimizeDisabled={this.props.minimizeDisabled}
          deleteDisabled={this.props.deleteDisabled}
          onToggleMinimize={this.onToggleMinimize}
          onMoveUp={this.props.onMoveUp}
          onMoveDown={this.props.onMoveDown}
          onDelete={this.props.onDelete}
        />
        {this.props.data.minimized ? '' : content}
      </div>
    );
  }
}

export default SingleExerciseEdit;

class SingleExerciseEditItem extends React.Component {
  constructor(props) {
    super(props);

    this.repsValueChanged = this.repsValueChanged.bind(this);
    this.repsUnitChanged = this.repsUnitChanged.bind(this);
    this.delete = this.delete.bind(this);
    this.validate = this.validate.bind(this);
  }
  repsValueChanged(e) {
    this.props.onChange(this.props.id, {
      reps: [e.target.value, this.props.data.reps[1]],
    });
  }
  repsUnitChanged(e) {
    this.props.onChange(this.props.id, {
      reps: [this.props.data.reps[0], e.target.value],
    });
  }
  delete() {
    this.props.onDelete(this.props.id);
  }
  validate(attribute) {
    if (
      this.props.tree &&
      this.props.tree[attribute] &&
      this.props.tree[attribute].length > 0
    ) {
      return 'invalid';
    }
    return;
  }
  render() {
    //console.log('[SingleExerciseEditItem] render() called.');
    let repUnitValue =
      this.props.data.reps instanceof Object ? this.props.data.reps[1] : 'reps';

    let labelText = '';
    if (this.props.overrideLabel) labelText = this.props.overrideLabel;
    else labelText = `Set ${this.props.id + 1}`;

    return (
      <div className="row spaced">
        <label>{labelText}</label>
        <input
          className={`reps smaller ${this.validate('reps')}`}
          type="number"
          min={0}
          max={100}
          pattern="\d*"
          ref="reps"
          value={this.props.data.reps[0]}
          onChange={this.repsValueChanged}
        />
        <select
          className="small"
          value={repUnitValue}
          onChange={this.repsUnitChanged}
        >
          <option value="reps">reps</option>
          <option value="sec">sec</option>
          <option value="min">min</option>
          <option value="meters">meters</option>
          <option value="calories">calories</option>
        </select>
        <label>
          <i onClick={this.delete} className="actionLink icon-remove"></i>
        </label>
      </div>
    );
  }
}

class RestEdit extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
  }
  onChange(ev) {
    let value = parseInt(ev.target.value);
    if (value > 0) this.props.onChange(value);
    else this.props.onChange(null);
  }
  render() {
    let rowContent = <span className="thin">none</span>;
    if (this.props.value > 0) {
      rowContent = (
        <span className="thin">
          <strong className="thin">{this.props.value}</strong> seconds
        </span>
      );
    }
    return (
      <div>
        <label>Rest between sets: {rowContent}</label>
        <input
          className="rest"
          type="range"
          min={0}
          max={300}
          step={5}
          onChange={this.onChange}
          value={this.props.value ? this.props.value : 0}
        />
      </div>
    );
  }
}
